import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

// Handles Google OAuth callback: reads session_id from URL fragment, exchanges
// it for a session_token via backend, then routes to /account.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate('/login'); return; }
    (async () => {
      try {
        const { data } = await api.googleSession(sessionId);
        setUser(data.user);
        window.history.replaceState({}, document.title, '/account');
        navigate('/account', { state: { user: data.user } });
      } catch (e) {
        setError('Sign-in failed. Please try again.');
        setTimeout(() => navigate('/login'), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-accent mx-auto mb-3" />
        <p className="text-muted-foreground">{error || 'Signing you in…'}</p>
      </div>
    </div>
  );
}
